import React, { useState } from "react";
import ScrollMenu from "react-horizontal-scrolling-menu";
import TextTruncate from "react-text-truncate";
import projects from "../../data/projects.json";
import Modal from "../modal";

type DataProps = {
  // children: any;
};

const Work: React.FC<DataProps> = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  return (
    <div id="portfolio" className="p-5 pt-10">
      {selectedProject != null && showModal && (
        <Modal
          key={"modal-" + selectedProject.name}
          toggleModal={() => {
            setShowModal(false);
          }}
          showModal={showModal}
          tittle={selectedProject.name}
        >
          <div className="">
            {/* <h2>{selectedProject.name}</h2> */}
            <p className="py-5">{selectedProject.description}</p>
            <ScrollMenu
              data={
                selectedProject?.photos?.map((photo: any, i: any) => {
                  return (
                    <div key={"work-" + photo}>
                      <img
                        className="h-56 pr-8 pl-2 pointer-events-none"
                        src={`../../img/projects/${photo}`}
                      />
                    </div>
                  );
                }) || []
              }
              itemClass="pointer-events-none"
              inertiaScrolling={false}
              //   key={"selected" + selectedProject.name}
              scrollBy={1}
              selected={null}
              transition={1}
              clickWhenDrag={true}
              arrowLeft={<div className="p-2 cursor-pointer">{"<"}</div>}
              arrowRight={<div className="p-2 cursor-pointer">{">"}</div>}
              alignCenter={false}
              dragging={true}
              wheel={true}
              scrollToSelected={false}
              hideSingleArrow={true}
              hideArrows={true}
            />
          </div>
        </Modal>
      )}
      <div className="grid grid-cols-7 pb-10">
        <div className="col-span-1 content-center mt-10">
          <hr className="border-gray-400" />
        </div>

        <div className="pl-3 col-span-6 col-start-2 text-4xl ">
          <div className=" text-4xl">
            Portfolio{" "}
            <small className="pl-1 -mt-2 md:-mt-8 block sm:inline text-xs">
              Some of projects i worked on
            </small>
          </div>
        </div>
      </div>
      <div
        className="grid md:grid-cols-2 lg:grid-cols-3 xs:grid-cols-1"
        style={{
          justifyItems: "center",
        }}
      >
        {projects.map((project) => {
          return (
            <div className="py-5 shadow-lg max-w-lg">
              <div className="flex  px-5 flex-col justify-center">
                <div className="text-lg flex justify-center">
                  <img
                    className=" justify-center h-32  w-auto mb-2 border-black"
                    style={{
                      maxWidth: "200px",

                      objectFit: "contain",
                    }}
                    src={`../../img/projects/${project.logo}`}
                  ></img>
                </div>
                <div className="flex-1 flex flex-col items-stretch content-center">
                  <div className="text-2xl ">{project.name}</div>
                  <div className="py-2">
                    <div className="font-light   text-sm text-justify text-gray-900">
                      {/* <Truncate
											css={{ textAlign: "justify" }}
											lines={3}
											ellipsis={"..."}
										>
											{project.description}
										</Truncate> */}
                      <TextTruncate
                        line={3}
                        element="span"
                        truncateText="…"
                        text={project.description}
                        textTruncateChild={<></>}
                      />
                    </div>
                    <div
                      className="underline text-base cursor-pointer"
                      onClick={() => {
                        setSelectedProject(project);
                        setShowModal(true);
                      }}
                    >
                      Read more...
                    </div>
                  </div>

                  {/* <div className='mt-auto '>
										<button
											className=''
											onClick={() => {
												setSelectedProject(project);
												setShowModal(true);
											}}
										>
											Read more...
										</button>
									</div> */}
                  <div className="flex  flex-wrap">
                    {project.tech.map((t) => (
                      <div
                        key={"used" + t}
                        className="border-solid mt-3 border border-black p-1 mr-2 text-xs hover:bg-black hover:text-white"
                      >
                        {t}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Work;
